import React from 'react'
import { colors } from '@fs/zion-ui'
import RoundedCard from '../../../merge-common/layout/RoundedCard'
import InBetweenBorderGrid from '../../../merge-common/layout/InBetweenBorderGrid'
import { MERGE_DIFF_PX_AMOUNT } from '../../../merge-common/helpers'
import MergeColumnSkeleton from './MergeColumnSkeleton'
import VitalsSectionSkeleton from './new-sections/vitals/VitalsSectionSkeleton'

/** Loading placeholder for the resultant column. Mirrors ResultantCard: the person card above its sections. */
export default function ResultantCardSkeleton(): JSX.Element {
  return (
    <RoundedCard style={{ borderColor: colors.blue60, marginInlineStart: `-${MERGE_DIFF_PX_AMOUNT}` }}>
      <InBetweenBorderGrid>
        <MergeColumnSkeleton personType="resultant" />
        <VitalsSectionSkeleton isResultant />
      </InBetweenBorderGrid>
    </RoundedCard>
  )
}
